import { render, staticRenderFns } from "./ElseInfo.vue?vue&type=template&id=fab664b4&scoped=true&"
import script from "./ElseInfo.vue?vue&type=script&lang=js&"
export * from "./ElseInfo.vue?vue&type=script&lang=js&"
import style0 from "./ElseInfo.vue?vue&type=style&index=0&id=fab664b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab664b4",
  null
  
)

export default component.exports